export default "__VITE_ASSET__CmFiZP7K__"